import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Platform from "@/pages/Platform";
import ForAgencies from "@/pages/ForAgencies";
import FreeScore from "@/pages/FreeScore";
import Auth from "@/pages/Auth";
import PartnerApply from "@/pages/PartnerApply";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Terms from "@/pages/legal/Terms";
import Privacy from "@/pages/legal/Privacy";
import Disclaimer from "@/pages/legal/Disclaimer";
import Refund from "@/pages/legal/Refund";
import DashboardLayout from "@/components/DashboardLayout";
import DashboardHome from "@/pages/dashboard/Home";
import Profile from "@/pages/dashboard/Profile";
import Opportunities from "@/pages/dashboard/Opportunities";
import Triage from "@/pages/dashboard/Triage";
import Roadmap from "@/pages/dashboard/Roadmap";
import Crm from "@/pages/dashboard/Crm";
import Intel from "@/pages/dashboard/Intel";
import Billing from "@/pages/dashboard/Billing";
import PaymentMethod from "@/pages/dashboard/PaymentMethod";
import Settings from "@/pages/dashboard/Settings";
import Marketplace from "@/pages/dashboard/Marketplace";
import Team from "@/pages/dashboard/Team";
import Admin from "@/pages/dashboard/Admin";
import Referrals from "@/pages/dashboard/Referrals";
import OnboardingCard from "@/pages/OnboardingCard";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/platform" element={<Platform />} />
      <Route path="/for-agencies" element={<ForAgencies />} />
      <Route path="/readiness" element={<FreeScore />} />
      <Route path="/login" element={<Auth />} />
      <Route path="/signup" element={<Auth />} />
      <Route path="/partner-apply/:token" element={<PartnerApply />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password/:token" element={<ResetPassword />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/disclaimer" element={<Disclaimer />} />
      <Route path="/refund-policy" element={<Refund />} />
      <Route path="/onboarding/card" element={<OnboardingCard />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardHome />} />
        <Route path="profile" element={<Profile />} />
        <Route path="opportunities" element={<Opportunities />} />
        <Route path="triage" element={<Triage />} />
        <Route path="roadmap" element={<Roadmap />} />
        <Route path="crm" element={<Crm />} />
        <Route path="intel" element={<Intel />} />
        <Route path="marketplace" element={<Marketplace />} />
        <Route path="team" element={<Team />} />
        <Route path="referrals" element={<Referrals />} />
        <Route path="admin" element={<Admin />} />
        <Route path="billing" element={<Billing />} />
        <Route path="payment-method" element={<PaymentMethod />} />
        <Route path="settings" element={<Settings />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
